import React, { useEffect, useContext, useState, Fragment } from 'react';
import axios from 'axios';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import { Alert } from '../../componentes/ui/Alert';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Spinner from 'react-bootstrap/Spinner';
import { alertService } from '../../services/alertservice';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { SRLWrapper } from 'simple-react-lightbox';

import { getApiUrl, axiosPost, getTitle, getDecodedCookie } from '../../helpers/helperApp';
import FormRow from '../../componentes/formulario/FormRow';

function Iomovements(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg } = useLogicForm();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ fec, saveFec ] = useState(null);
    const [ movimientos, saveMovimientos ] = useState([]);
    const [ totales, saveTotales ] = useState([]);
    const [ info, saveInfo ] = useState({nomuni : "", nomcen: ""})
    const [ loading, saveLoading ] = useState(false);

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {                
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                    
                    document.title = getTitle(confPantalla.config.trad, "Movimientos");                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);                        
                        // Seleccionar el id que nos llega como parámetro por la url
                        if( props.location.state && "iduni" in props.location.state && "idcen" in props.location.state && "fec" in props.location.state){
                            saveFec(props.location.state.fec);
                            getInfo(props.location.state.iduni, props.location.state.idcen);
                            getMovimientos(props.location.state.iduni, props.location.state.idcen, props.location.state.fec);
                            getTotales(props.location.state.iduni, props.location.state.idcen, props.location.state.fec);
                        }else{
                            saveTieneNivel(false);
                        }                      
                    }else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 
        
    },[confPantalla])


    const getInfo = async(idUni, idCen) => {
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idcen", idCen);
        data.append("iduni", idUni);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/iomovements/getinfo', data);           
        if( typeof respuesta.data == "string" ){
            alertService.error(`<i className="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
        }else{            
            saveInfo(respuesta.data);
        } 
    }

    const getMovimientos = async(idUni, idCen, fec) => {
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idcen", idCen);
        data.append("iduni", idUni);
        data.append("fec", fec);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/iomovements/getmovimientos', data);           
        if( typeof respuesta.data == "string" ){
            alertService.error(`<i className="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
        }else{            
            saveMovimientos(respuesta.data);
        } 
    }

    const getTotales = async(idUni, idCen, fec) => {
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idcen", idCen);
        data.append("iduni", idUni);
        data.append("fec", fec);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/iomovements/gettotales', data);           
        if( typeof respuesta.data == "string" ){
            alertService.error(`<i className="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
        }else{                        
            saveTotales(respuesta.data);
        } 
    }

 

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <SRLWrapper>
                        <Fragment>
                        {
                            loadedConf === true && confPantalla !== undefined
                            ?
                            <Section titulo={"Movimientos"} icono={ "fa-thin fa-arrow-progress" } col={ 12 } idPrin={ 0 } >                                    
                                    <FormRow>
                                        <div className={"form-group col-md-12"}>
                                            <label style={{textDecoration: "underline"}}>{info.nomcen}:</label>
                                            <p dangerouslySetInnerHTML={{ __html: info.nomuni }} />                                                
                                        </div>                                        
                                    </FormRow>                                    
                                    <MiDataTable
                                        formulario={{id:0}}
                                        estadoForm= { "" }
                                        id={"tabmovements"}
                                        columnas={[                                                
                                                { "title": "Tipo operación", "data": "tipdoc"},
                                                { "title": "Fecha", "data": "fecha"},
                                                { "title": "Cantidad", "data": "cantidad", "class" : "text-right"},
                                                { "title": "Descripción", "data": "descripcion" },
                                                { "title": "Ubicacion", "data": "ubicacion"}                                      
                                            ]}
                                        data={movimientos}                                
                                        order={[]}                                
                                        pagelength={25}                                                                
                                        saveLoadingTable={ saveLoading }
                                        // loadingTable={loading}                                
                                        traduction={confPantalla.config.trad.components.datatable}                                                               
                                    />
                                    <MiDataTable 
                                        estadoForm= { "" }
                                        formulario={ {id:0} }
                                        id={"stockart"}
                                        columnas={[                                            
                                                    { "title": "Ubicación", "data": "ubicacion", "width" : "85%" },
                                                    { "title": "Unidades", "data": "unidades" }
                                                ]}                                        
                                        data={totales}                                        
                                        order={[]}                                       
                                        pagelength={-1}
                                        saveLoadingTable={ saveLoading }
                                        // loadingTable={loadingTable}                                        
                                        traduction={confPantalla.config.trad.components.datatable}
                                    />
                            </Section>
                            :
                                <LoadingPage />
                            }
                        </Fragment>
                    </SRLWrapper>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Iomovements